export const gallic = [
    {id:1,   name:"Phalanx", wood:100, clay:130, iron:55, crop:30},
    {id:2,   name:"Swordsman", wood:140, clay:150, iron:185, crop:60},
    {id:3,   name:"Pathfinder", wood:170, clay:150, iron:20, crop:40},
    {id:4,   name:"Theutates Thunder", wood:350, clay:450, iron:230, crop:60},
    {id:5,   name:"Druidrider", wood:360, clay:330, iron:280, crop:120},
    {id:6,   name:"Haeduan", wood:500, clay:620, iron:675, crop:170 	},
    {id:7,   name:"Ram", wood:950, clay:555, iron:330, crop:75},
    {id:8,   name:"Trebuchet", wood:960, clay:1450, iron:630, crop:90},
    {id:9,   name:"Chieftain", wood:30750, clay:45400, iron:31000, crop:37500},
    {id:10,  name:"Settler", wood:4400, clay:5600, iron:4200, crop:3900}
    ]